import PracticeSettingsService from './PracticeSettingsService';
import { PRACTICE_PLAYER_MODES } from './PracticePlayerService';

export function buildPracticePlayerProgress(card, completedPlaybacks, mode, timestamp = new Date().toISOString()) {
  const repeatDelta = Math.max(0, Math.floor(Number(completedPlaybacks) || 0));
  const currentRepeats = PracticeSettingsService.getCardPracticeCount(card);
  const currentScore = PracticeSettingsService.getCardScore(card);
  const isReview = mode === PRACTICE_PLAYER_MODES.REVIEW;
  const isReading = PracticeSettingsService.getCardType(card) === PracticeSettingsService.CARD_TYPES.READING;
  const scoreLimit = PracticeSettingsService.getCardScoreLimit(card);
  const scoreDelta = isReview
    ? repeatDelta
    : Math.min(repeatDelta, Math.max(0, scoreLimit - currentScore));
  const projectedRepeats = currentRepeats + repeatDelta;
  const projectedScore = currentScore + scoreDelta;
  const reachesLimit = isReading
    ? projectedRepeats >= scoreLimit
    : projectedScore >= scoreLimit;
  const scoreGraduated = !isReview && !PracticeSettingsService.isGraduated(card) && reachesLimit;
  const graduationType = scoreGraduated ? PracticeSettingsService.GRADUATION_TYPES.SCORE : null;
  const completedAt = scoreGraduated ? timestamp : null;
  const update = {
    id: card.id ?? card._id,
    practiceCountDelta: repeatDelta,
    scoreDelta,
    progressedAt: repeatDelta > 0 || scoreDelta > 0 ? timestamp : null,
    assessments: [],
    testIndex: null,
    graduationType,
    completedAt,
  };
  const updatedCard = {
    ...card,
    practiceCount: projectedRepeats,
    score: projectedScore,
  };

  if (scoreGraduated) {
    updatedCard.graduationType = graduationType;
    updatedCard.completedAt = card.completedAt || completedAt;
  }

  return {
    update,
    updatedCard,
    evaluation: null,
    graduated: scoreGraduated,
    repeatDelta,
    scoreDelta,
  };
}

const PracticePlayerProgressService = { buildPracticePlayerProgress };

export default PracticePlayerProgressService;
